import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './idb-powerbi-embed.css.lit';

/**
 * The IdbUtilityMenu component
 * @element idb-powerbi-embed
 */
@customElement('idb-powerbi-embed')
export class IdbPowerbiEmbed extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  @property({ type: String, reflect: true, attribute: 'url' }) url: string;

  @property({ type: String, attribute: 'width' })
  width = '388';

  @property({ type: String, attribute: 'height' })
  height = '720';

  render(): TemplateResult {
    return html`<div class="powerbi-embed">
      <iframe
          width="${this.width}"
          height="${this.height}"
          src="${this.url}"
          frameborder="0"
          allowfullscreen="true"
      ></iframe>
    </div>`;
  }
}
